import * as React from "react";
import {cx} from "emotion";

import "./edit-shipping-address-modal.scss";

import {cs}                from "@Common/react/chain-services";
import {consumeContext}    from "@Common/react/context";
import {Static2}           from "@Common/react/static-2";
import {UseState}          from "@Common/react/use-state";
import {ConfirmDialog}     from "@Common/ui-components/heavy/common/design2/dialogs/confirm-dialog/confirm-dialog";
import {ModalService3}     from "@Common/ui-components/modal-service-3/modal-service-3";
import {needsConfirmation} from "@Common/ui-components/needs-confirmation/needs-confirmation";
import {chain}             from "@Common/utils/fs";

import {ShippingAddressForm} from "../../../../../common/shipping-address-form/shipping-address-form";
import {SliderCheckboxLine}  from "../common/shipping-address-form-2/slider-checkbox-line/slider-checkbox-line";

export const EditShippingAddressModal = ({agentId=undefined, next: rootNext}) => cs(
    ["confirmCloseDialog", ({}, next) => ConfirmDialog({next})],
    ["hasUnsavedChangesStatic", ({}, next) => Static2({next, getInitValue: () => false})],
    ["modal", ({confirmCloseDialog, hasUnsavedChangesStatic}, next) => ModalService3<any>({
        xdQaName: "Edit Shipping Address Modal",
        next: ({params: {onDone, address, lockedAsDefault}, close}) => next({
            onDone,
            address,
            lockedAsDefault,
            close,
        }),
        // initShow: isDevQuan(),
        onPassiveClose: async () => {
            return !hasUnsavedChangesStatic.get() || await needsConfirmation({
                confirmDialog: confirmCloseDialog,
            });
        },
        rootNext,
    })],
    ["showErrors", (_, next) => UseState({next})],
    ["submitting", (_, next) => UseState({next})],
    ["form", ({modal, hasUnsavedChangesStatic}, next) => ShippingAddressForm({
        initValue: modal.address,
        hasUnsavedChangesStatic,
        next
    })],
    consumeContext("apis"),
    ({form, showErrors, submitting, confirmCloseDialog, modal, hasUnsavedChangesStatic, apis}) => (
        <div className="edit-shipping-address-modal-2-6es">

            <div className="header">
                <div {...{
                    className: "title",
                    "xd-qa-type": "label",
                    "xd-qa-name": "Edit Shipping Address",
                }}>
                    Edit Shipping Address
                </div>
            </div>

            <div className="main">
                {form.render({
                    showErrors: showErrors.value,
                    lockedAsDefault: modal.lockedAsDefault
                })}

                {SliderCheckboxLine({
                    label: "Set as default Shipping Address",
                    xdQaName: "Set as default Shipping Address",
                    className: "defaultBranch",
                    ...modal.lockedAsDefault ? {
                        value: true,
                    } : chain(
                        form.form.field("defaultBranch"),
                        (field) => ({
                            value: field.value,
                            onChange: (value) => {
                                hasUnsavedChangesStatic.set(true);
                                field.onChange(value);
                            },
                        })
                    ),
                })}
            </div>

            <div className="footer">
                <button
                    xd-qa-type="button" 
                    xd-qa-name="Cancel Add Shipping Address"
                    className="cancel"
                    onClick={async () => {
                        const confirmed = !hasUnsavedChangesStatic.get() || await needsConfirmation({
                            confirmDialog: confirmCloseDialog,
                        });
                        if (confirmed) {
                            modal.close();
                        }
                    }}
                >
                    Cancel
                </button>
                <button
                    xd-qa-type="button" 
                    xd-qa-name="Save"
                    className={cx("next", {disabled: !form.form.validate()})}
                    disabled={!hasUnsavedChangesStatic.get() || submitting.value}
                    onClick={async () => {
                        if(!form.form.validate()) {
                            showErrors.onChange(true);
                        } else {
                            submitting.onChange(true)
                            // TODO need agentId?
                            await apis.next.shipping.updateShippingAddress({
                                id: modal.address.idPrimary,
                                address: {
                                    ...form.form.value,
                                },
                                agentId,
                            });
                            modal.onDone({
                                ...form.form.value,
                                idPrimary: modal.address.idPrimary,
                            });
                            submitting.onChange(false)
                            modal.close();
                        }
                    }}
                >
                    Save
                </button>
            </div>
        </div>
    )
);